var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","content-class":"custom-top-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-chip',_vm._g(_vm._b({attrs:{"label":""}},'v-chip',attrs,false),on),[_vm._v(" "+_vm._s(_vm.humanFormat)+" ")])]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.systemFormat)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }